module.exports = __webpack_public_path__ + "static/media/architecture-bay-boats-799091.76973669.jpg";